import clsx from 'clsx';
import { DONATION_TONE } from '../../constants/donation.const';
import { taxStatusLabel } from '../../utils/donation-format';

/** Whether a charity's receipts can be used for tax relief, as a small pill. */
export function TaxStatusTag({ taxDeductible }: { taxDeductible: boolean }) {
  return (
    <span
      className={clsx(
        'inline-flex w-fit items-center rounded-full px-2 py-0.5 text-xs font-medium',
        taxDeductible ? DONATION_TONE.pill : 'bg-gray-100 text-gray-600'
      )}
    >
      {taxStatusLabel(taxDeductible)}
    </span>
  );
}
